import React from "react";
import { motion } from "framer-motion";
import VideoPlayer from "./VideoPlayer";
import Title from "../title/Title";
const Teaching = ({videoListData}) => {
  return (
    <motion.div
      initial={{ y: "100%", opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
         <Title
          title="2018 - PRESENT"
          desc="My Journey as a Teacher "
          fontSize="text-2xl md:text-4xl"
        />
      <VideoPlayer videoListData={videoListData} />
    </motion.div>
  );
};

export default Teaching;
